import { Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';

import { HlmFieldImports } from '@spartan-ng/helm/field';
import { SidepanelService } from '../../../../../shared/components/sidepanel/sidepanel.service';
import { ToastrSuccessComponent } from '../../../../../shared/components/toastr/toastr-success.component';
import { LabelRequiredDirective } from '../../../../../shared/directives/label-required.directive';
import { Phase } from '../../models/phase.model';
import { PhaseStore } from '../../store/phase.store';

@Component({
  selector: 'app-form-phase',
  imports: [HlmInputImports, ReactiveFormsModule, LabelRequiredDirective, LabelRequiredDirective, HlmFieldImports],
  templateUrl: './form-phase.component.html',
})
export class FormPhaseComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #store = inject(PhaseStore);

  readonly phase = input.required<Phase>();

  form = this.#fb.group({
    nom: ['', Validators.required],
  });

  constructor() {
    effect(() => this.nom.setValue(this.phase().nom));
  }

  ngOnInit(): void {
    this.#sidepanelService.submit.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.onSubmit());
  }

  onSubmit() {
    if (this.nom.hasError('required')) {
      return;
    }
    const toastrId = uuidv7();

    const phase = { nom: this.nom.value, indice: this.phase().indice, idReferentiel: this.phase().idReferentiel };

    this.#store.modifier({
      idPhase: this.phase().id,
      data: phase,
      next: () => {
        toast.custom(ToastrSuccessComponent, {
          componentProps: { message: 'Modification de la phase réussie', id: toastrId },
          id: toastrId,
        });
        this.#sidepanelService.close();
        this.#store.charger(this.phase().idReferentiel);
      },
      error: () => this.alreadyExists(phase),
    });
  }

  alreadyExists(phase: { nom: string }) {
    const phases = this.#store.entities().map((x) => x.nom);
    const doublonsAvecPhasesExistantes = phases.filter((x: string) => phase.nom === x);

    if (doublonsAvecPhasesExistantes.length > 0) {
      this.nom.setErrors({ notUnique: true });
    }
  }

  get nom() {
    return this.form.get('nom') as FormControl<string>;
  }
}
